export const initExtra = {
  isRestarting: undefined,
  native_language: undefined,
  wholesome_conditions: undefined,
  finished: false,
  elapsed_time: 0,
}

export const factoryTest = (item) => {
  return {
    version: "en_US_2.0.0",
    locale_id: 2,
    data: item,
  }
}

export const factoryStart = {
  version: "en_US_2.0.0",
  locale_id: 2,
  start: true,
  data: {},
}

export const factoryItem = [
  {
    item_id: "item_id_022",
    time_initial: 87,
    moves: 4,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "c1v1",
      DropZone2: "c1s1",
      DropZone3: "c1b1",
    },
  },
  {
    item_id: "item_id_069",
    time_initial: 23,
    moves: 2,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "23c2",
    },
  },
  {
    item_id: "item_id_030",
    time_initial: 42,
    moves: 2,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "3c1",
      DropZone2: "7c1",
    },
  },
  {
    item_id: "item_id_060",
    time_initial: 22,
    moves: 2,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "0c1",
    },
  },
  {
    item_id: "item_id_055",
    time_initial: 37,
    moves: 6,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "c2h2v2",
    },
  },
  {
    item_id: "item_id_058",
    time_initial: 13,
    moves: 4,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "c1h1",
    },
  },
  {
    item_id: "item_id_014",
    time_initial: 22,
    moves: 2,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "-2c1",
    },
  },
  {
    item_id: "item_id_019",
    time_initial: 18,
    moves: 5,
    resets: 0,
    oversights: 0,
    incomplete: false,
    answers: {
      DropZone1: "c1h1",
      DropZone2: "c1h1",
    },
  },
  {
    item_id: "item_id_015",
    time_initial: 32,
    moves: 0,
    resets: 0,
    oversights: 0,
    incomplete: true,
    answers: {
      DropZone1: "NA",
      DropZone2: "NA",
      DropZone3: "NA",
    },
  },
]
